const burger = document.querySelector('.burger')
const search = document.querySelector('.search-trigger')
const body = document.body

if(burger) {
    burger.addEventListener('click', e => {
        burger.classList.toggle('active')
        body.classList.toggle('mobile-open')
    })

    search.addEventListener('click', () => {
        burger.classList.toggle('active')
        body.classList.toggle('mobile-open')
    });
}
